import { render, staticRenderFns } from "./Risikobewertung.vue?vue&type=template&id=2a82b197&scoped=true"
import script from "./Risikobewertung.vue?vue&type=script&lang=js"
export * from "./Risikobewertung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a82b197",
  null
  
)

export default component.exports